import URI from 'jsuri';

import logger from 'js/app/loggerSingleton';

const exported = {
  /**
   * If <key>=<val> is found in the current url, take it out silently and return <val>.
   * Otherwise, no action is taken and the function returns false.
   * @param  {string} key
   * @return {string|Boolean}
   */
  parseAndDeleteQueryParam(key: $TSFixMe) {
    if (typeof window === undefined) {
      logger.error('parseAndRemoveQueryParam is called but window is undefined');
      return false;
    }

    const uri = new URI(window.location.href);
    const val = uri.getQueryParamValue(key);
    if (!val) {
      return false;
    }

    uri.deleteQueryParam(key);
    history.replaceState({}, '', uri.toString());

    return val;
  },
};

export default exported;

export const { parseAndDeleteQueryParam } = exported;
